var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('entities-list-short',{attrs:{"entities":_vm.entitiesArray,"title":_vm.title ? _vm.title : _vm.$t('NftContractSigners.title'),"subtitle":_vm.subtitle ? _vm.subtitle : _vm.$t('NftContractSigners.subtitle')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }